<!-- 养老A类基金 当前基金为养老Y类基金且存在A类基金code时展示 -->
<template>
  <div v-if="!$isEmpty(aFundCode) && !$isEmpty(aFundInfo)" class="pension-box" @click="$goFundApp">
    <!-- 顶部标题 -->
    <div class="top-title row">
      <div class="top-tip">当前基金为Y类份额，点击查看该基金A类份额</div>
      <div class="more-detail row">
        <div class="more-text">详情</div>
        <img :src="blueArrow" class="arrow"/>
      </div>
    </div>
    <!-- 基金内容 -->
    <div class="fund-content row">
      <img v-if="!$isEmpty(aFundInfo.syl)" :src="aFundInfo.image" class="syl-img"/>
      <div v-else class="syl-img empty-img">成立未满6月</div>
      <div class="fund-info">
        <div class="fund-name">{{aFundInfo.aFundName}}</div>
        <div class="syl-info row">
          <div class="syl-date">{{aFundInfo.date}}</div>
          <div class="syl-value" :style="{color: getRateColor(aFundInfo.syl)}"
            >{{aFundInfo.syl}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tool from '../../../utils/tool';

export default {
  name: 'fund-pension-a',

  props: {
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      aFundInfo: {}, // 对应A类基金信息（来自接口）
      blueArrow: 'https://j5.dfcfw.com/sc/image/202211/20221117112342.png',
    };
  },

  computed: {
    aFundCode() {
      return this.detailInfo?.yPensionFundCode || '';
    },
  },

  watch: {
    aFundCode() {
      console.log('====> aFundCode', this.aFundCode);
      if (!this.$isEmpty(this.aFundCode)) {
        this.getAFundInfo();
      }
    },
  },

  methods: {
    getRateColor: tool.getRateColor,
    getAFundInfo() {
      this.$http.useRequests('FundComApi.getFundBaseInfo', { FCODES: this.aFundCode })
        .then((res) => {
          let data = {};
          if (res?.success) {
            [data] = res.data;
          }
          const {
            SHORTNAME, SYL_1N, SYL_6Y, SYL_3N,
          } = data;
          let syl;
          let date;
          let sylType;
          if (String(SYL_3N) && String(SYL_3N) !== '--') {
            syl = Number(SYL_3N).toFixed(2);
            date = '近3年';
            sylType = 'SYL_3N';
          } else if (String(SYL_1N) && String(SYL_1N) !== '--') {
            syl = Number(SYL_1N).toFixed(2);
            date = '近1年';
            sylType = 'SYL_1N';
          } else if (String(SYL_6Y) && String(SYL_6Y) !== '--') {
            syl = Number(SYL_6Y).toFixed(2);
            date = '近6月';
            sylType = 'SYL_6Y';
          } else {
            syl = '--';
            date = '--';
            sylType = '--';
          }
          this.aFundInfo = {
            aFundName: SHORTNAME,
            aFundCode: this.aFundCode,
            syl: this.$isEmpty(syl) ? '--' : `${syl}%`,
            date,
            image: `https://j3.dfcfw.com/images/apphome1/${sylType}/${this.aFundCode}.png`,
          };
          console.log('===> aFundInfo', this.aFundInfo);
        })
        .catch((err) => { console.log('getAFundInfo ERR', err); });
    },
  },
};
</script>

<style lang="less" scoped>
.pension-box {
  width: 100%;
  padding: 24px;
  box-sizing: border-box;
  border-radius: 12px;
  background-color: #ffffff;
  margin-bottom: 24px;
}
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.top-title {
  justify-content: space-between;
  font-size: 26px;
}
.top-tip {
  color: #333333;
}
.more-text {
  color: #008AFF;
}
.arrow {
  width: 10px;
  height: 17px;
  margin-left: 8px;
}
.fund-content {
  margin-top: 27px;
  justify-content: flex-start;
}
.syl-img {
  width: 103px;
  height: 83px;
}
.empty-img {
  color: #999999;
  font-size: 24px;
  text-align: center;
  line-height: 41px;
}
.fund-info {
  margin-left: 36px;
}
.fund-name {
  font-size: 28px;
  color: #333333;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 显示省略号 */
}
.syl-info {
  justify-content: flex-start;
  align-items: flex-end;
}
.syl-date {
  font-size: 24px;
  font-weight: 400;
  color: #999999;
}
.syl-value {
  font-family: DINAlternate-Bold;
  font-size:42px;
  margin-left: 10px;
  font-weight: 700;
}
</style>
